
/********************Get Browser Vesion********************/
function getBrowserVer() {
    var nVer = navigator.appVersion,
        nAgt = navigator.userAgent,
        browserName = navigator.appName,
        fullVersion = '' + parseFloat(navigator.appVersion),
        majorVersion = parseInt(navigator.appVersion, 10),
        nameOffset, verOffset, ix,
        msg = '';


    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
            fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
            fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }
    var infoBrowser = {
        'browserName': browserName,
        'fullVersion': fullVersion,
        'majorVersion': majorVersion,
        'navigator.appName': navigator.appName,
        ' navigator.userAgent': navigator.userAgent, 'msg': msg
    }
    return infoBrowser;
}
//*****************End Get Browser Version************************ /

if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
    }
}

var graph, data;
/// arrNode first use for sort



var arrNode = [],
    maxNumber = 0,
    nodeDraw,
    edgesDraw,
    optDraw,
    idCanvas,
    idView,
    container,
    obj = {},
    optionsInit = {
        edges: {
            length: 600,
            style: 'arrow-center',
            color: 'green',
            fontSize: 20,
            fontFace: 'Quran_Taha,Scheherazade'
        },
        nodes: {
            // default for all nodes
            fontFace: 'B Mitra',
            shape: 'text',
            fontSize: 22

        },
        groups: {
            'POW': {
                // defaults for nodes in this group
                fontFace: 'Quran_Taha,Scheherazade',
                fontSize: 15,
                shape: 'dot',

                color: {

                    border: 'red'

                }
            },
            'W': { fontSize: 35, fontFace: 'Quran_Taha,Scheherazade' }



        },
        physics: {
            barnesHut: {
                //                            enabled: true,
                gravitationalConstant: 0,//نيروي گرانشي ميان دو جسم نيروي دافعه
                centralGravity: -0.14 //سنگيني را به وسط متمرکز مي کند


            }

        },
        navigation: {
            enabled: true
        },
        keyboard: {
            speed: { x: 10, y: 10, zoom: 0.02 }
        }
        //
        //        stabilize:'true',
        //        stabilizationIterations:'0'


    };

// window.onresize = function () {
//     draw(nodeDraw, edgesDraw, optDraw);

// };

// function init() {
//     createViewForQuranAnalyze(objR, idCanvas, idView);

// }

export default function createViewForQuranAnalyze(objR, idCan, idVi, sarfContainerId, callback) {
    idCanvas = idCan;
    idView = idVi;
    container = document.getElementById(idView);
    obj.ayeh = {};
    obj.ayeh.node = objR.ayeh.node.Data;
    obj.ayeh.edge = objR.ayeh.edge.Data;
    obj.ayeh.text = objR.ayeh.text;
    obj.attr = objR.attr.Data;
    obj.relationName = SetIdForNameObjRelation(objR.relationName);
    //document.getElementById("textAyeh").innerHTML = obj.ayeh.text;

    nodeDraw = createNode(obj.ayeh, sarfContainerId);
    edgesDraw = createEdge(obj.ayeh.edge, obj.ayeh.node);
    optDraw = optionsInit;
    optDraw.groups = funCreateGroup(optDraw.groups, obj.attr);
    draw(nodeDraw, edgesDraw, optDraw);
    if (typeof callback === 'function') {
        callback();
    }
}

// parse and draw the data
function draw(nodes, edges, options) {
    if (container != undefined) {
        
        //    txtError.innerHTML = '';

        // create a graph
        var data = {
            nodes: nodes,
            edges: edges
        };

        graph = new vis.Graph(container, data, options);

        //document.getElementById('btnAnalyzeAye').blur();
        //        graph.storePosition(400,600);
        //        graph.setSize('100%','100%');
        //        graph.canvasBottomRight.x=100;
        //        graph.frame.offsetLeft=100;
        //        graph.pointerPosition.x=100;
        graph.scale = .5;
        if (data.edges.length > 23) {
            graph.translation.x = 1150;
            graph.translation.y = 130;
        }
        else {
            var range = graph._getRange();
            graph._centerGraph(range);
        }
        //        graph.pointerPosition.x=-100;
        //        graph.pointerPosition.y=500;


        graph.off('select', onSelect);
        //        alert('df');
        graph.redraw();


    }
}

function onSelect(properties) {
    //alert('selected nodes: ' + properties.nodes);
}

function createData() {
    createNode(obj.node);
    createEdge(obj.edge);
}


/////////Create Nodes////////////////////////////////////////////////////////
function createNode(node, sarfContainerId) {
    var temp = setValNode(obj.ayeh.node, sarfContainerId, obj.ayeh.text),
        nodeFull = new Array();

    nodeFull.push({ id: '0', label: '', fontSize: '20', color: 'yellow' });
    for (var i in temp) {
        //funX(temp[i],temp);

        //nodeFull[i]={};

        nodeFull.push({ id: '' + temp[i].atr.atr + '.' + temp[i].id + '', x: temp[i].x, y: temp[i].y, label: '' + temp[i].Word + '', group: temp[i].group });
        nodeFull.push({ id: '' + temp[i].id + '', x: (temp[i].x - (temp[i]['length'] / 2)), title: '' + temp[i].atr.arabic + '', label: '', y: (temp[i].y + 50), group: ['POW', '' + temp[i].atr.atr + ''] });

    }

    return nodeFull;

}

/////////Create Edges////////////////////////////////////////////////////////
function createEdge(edge, node) {
    var temp = setValEdge(edge, node),
        edgeFull = new Array();
    edgeFull.push({ from: '0', to: '' + funGetId(arrNode) + '', width: 1, length: 200, color: 'white', style: 'line' });

    for (var i in temp) {

        edgeFull.push({ from: '' + temp[i].from + '', to: '' + temp[i].to + '', width: 1, length: temp[i].length, color: '' + temp[i].color + '', fontColor: '' + temp[i].color + '', label: '' + temp[i].label + '' + '', title: '' + temp[i].label + '' });
    }

    return edgeFull;
}


///Set Value For Nods////////////////////////////////////////////////
function setValNode(node, sarfContainerId, AyehTXT) {
    var arrId = new Array(), firstNodeId, length = 0, startX = -200, arrMahzoof = new Array(),
        //    strJoin = '\u0640',
        strHJoin = '\u0640' + '\u0640';
    //    strJoin = '\u0640' + '\u0640' + '\u0640' + '\u0640' + '\u0640' + '\u0640' + '\u0640' + '\u0640' + '\u0640',
    //    strHJoin = '\u0640' + '\u0640' + '\u0640' + '\u0640' + '\u0640' + '\u0640';


    
    for (var i in node) {
        length++;

        var currentNode = node[i],
            IdOfNode = currentNode.id;
        arrId[IdOfNode] = {};
        var currentNewNode = arrId[IdOfNode];


        currentNewNode['id'] = IdOfNode;
        currentNewNode['number'] = null;
        currentNewNode['nextId'] = currentNode['nextId'];
        currentNewNode['prevId'] = currentNode['prevId'];
        currentNewNode['idWord'] = currentNode['idWord'];
        var result = funAttr(currentNode['atrId'], obj.attr);
        if (result != null) {
            currentNewNode['group'] = ['W', '' + result.atr + ''];
            currentNewNode['atr'] = result;
        } 

        currentNewNode['state'] = funState(i, node);
        currentNode['Word'] = currentNode['Word'].trim();

        //Config Node for Crate Table Sarfff************************************************
        if (currentNode['xml']) {
            var xml = $.parseXML(currentNode['xml']),
                dxml = $(xml),
                $element = dxml.find("word");
            currentNewNode['StXML'] = {};
            currentNewNode['StXML']['Slice'] = $element.attr('Entry');
            currentNewNode['StXML']['Pos'] = $element.attr('Pos');
            currentNewNode['StXML']['Entry'] = $element.attr('Entry');
            currentNewNode['StXML']['Affix'] = $element.attr('Affix');

            currentNewNode['StXML']['color'] = currentNewNode['atr']['color'];


            if ($element.attr('Pos') == 'حرف') {
                currentNewNode['StXML']['Kol'] = $element.attr('Kol');
                currentNewNode['StXML']['Case'] = $element.attr('Case');
            } else if ($element.attr('Pos') == 'فعل') {
                currentNewNode['StXML']['Time'] = $element.attr('Time');
                currentNewNode['StXML']['Categ'] = $element.attr('Categ');
                currentNewNode['StXML']['Root'] = $element.attr('Root');
                currentNewNode['StXML']['TOV'] = $element.attr('TOV');
                currentNewNode['StXML']['Voic'] = $element.attr('Voic');
                currentNewNode['StXML']['Trans'] = $element.attr('Trans');
                currentNewNode['StXML']['Case'] = $element.attr('Case');
                currentNewNode['StXML']['Gender'] = $element.attr('Gender');
                currentNewNode['StXML']['Gend'] = $element.attr('Gend');
                currentNewNode['StXML']['RootT'] = $element.attr('RootT');
                currentNewNode['StXML']['Prsn'] = $element.attr('Prsn');
                currentNewNode['StXML']['Num'] = $element.attr('Num');
            } else if ($element.attr('Pos') == 'اسم') {
                currentNewNode['StXML']['Root'] = $element.attr('Root');
                currentNewNode['StXML']['Categ'] = $element.attr('Categ');
                currentNewNode['StXML']['DervT'] = $element.attr('DervT');
                currentNewNode['StXML']['Num'] = $element.attr('Num');
                currentNewNode['StXML']['Gend'] = $element.attr('Gend');
                currentNewNode['StXML']['Trans'] = $element.attr('Trans');
                currentNewNode['StXML']['Case'] = $element.attr('Case');
                currentNewNode['StXML']['Def'] = $element.attr('Def');
                currentNewNode['StXML']['RootT'] = $element.attr('RootT');
            }
        }


        if (currentNode['isNewWord'] == 1) {
            currentNode['Word'] = '[' + currentNode['Word'] + ']';
            if (currentNewNode['prevId'] != null && currentNewNode['nextId'] != null) {
                arrMahzoof.push(IdOfNode);
            }

        }

        switch (currentNewNode['state']) {
            case 'FiEn':
                currentNewNode['Word'] = currentNode['Word'];
                break;
            //            case'Fi':'\u0020'
            //                currentNewNode['Word']=currentNode['Word']+'\u200D';
            //                break;
            //            case'En':
            //                currentNewNode['Word']='\u200D'+currentNode['Word'];
            //                break;
            //            case'Ce':
            //                currentNewNode['Word']=currentNode['Word']+'\u200D';
            //                break;
            case 'Fi':
                currentNewNode['Word'] = '\u0020' + '\u0020' + '\u0020' + currentNode['Word'] + strHJoin;
                break;
            case 'FiAfSpl':
                currentNewNode['Word'] = '\u0020' + currentNode['Word'];
                break;
            case 'En':
                currentNewNode['Word'] = strHJoin + currentNode['Word'] + '\u0020';
                break;
            case 'EnBefSpl':
                currentNewNode['Word'] = currentNode['Word'] + '\u0020';
                break;
            case 'Ce':
                currentNewNode['Word'] = strHJoin + currentNode['Word'] + strHJoin;
                break;
            case 'CeAfSpl':
                currentNewNode['Word'] = strHJoin + currentNode['Word'];
                break;
            case 'CeBefSpl':
                currentNewNode['Word'] = currentNode['Word'] + strHJoin;
                break;
            case 'CeBefAfSpl':
                currentNewNode['Word'] = currentNode['Word'];
                break;
            default:
                currentNewNode['Word'] = currentNode['Word'];
                break;
        }

        //        currentNewNode['Word'] ='حنن' ;
        currentNewNode['length'] = GetLengthText(currentNewNode['Word']);
        //        currentNewNode['x']=funX(parseInt(i),currentNewNode['state'],0);
        currentNewNode['y'] = funY();
        if (currentNode['prevId'] == null) {
            currentNewNode['number'] = 1;
            firstNodeId = IdOfNode
        }
        //        if(currentNode['nextId']=='NULL'){currentNewNode['number']="end";}


    }


    //set Nubmer for node in Ayehe
    var a = 2,
        idNext = arrId[firstNodeId]['nextId'];
    for (var j = 1; j < length; j++) {
        arrId[idNext]['number'] = a;
        idNext = arrId[idNext]['nextId'];
        a++;

    }


    //for sent mahzoof  after word most run this code
    for (var j in arrMahzoof) {
        var MTemp = arrId[arrMahzoof[j]],
            PTemp,
            NTemp;
        PTemp = arrId[MTemp['prevId']];
        NTemp = arrId[MTemp['nextId']];
        if (PTemp['idWord'] == NTemp['idWord']) {
            shiftNode();
        }

        function shiftNode() {
            //set Number
            var tempNumber = MTemp['number'];
            MTemp['number'] = NTemp['number'];
            NTemp['number'] = tempNumber;

            //set Position
            PTemp['nextId'] = NTemp['id'];
            MTemp['prevId'] = NTemp['id'];
            MTemp['nextId'] = NTemp['nextId'];
            NTemp['prevId'] = PTemp['id'];
            NTemp['nextId'] = MTemp['id'];

            if (arrId[MTemp['nextId']] !== undefined && arrId[MTemp['nextId']] !== null)
                arrId[MTemp['nextId']]['prevId'] = MTemp['id'];


            PTemp = arrId[MTemp['prevId']];
            NTemp = arrId[MTemp['nextId']];

            if (PTemp !== undefined && PTemp['idWord'] !== undefined && PTemp['idWord'] !== null
                && NTemp !== undefined && NTemp['idWord'] !== undefined && NTemp['idWord'] !== null)
                if (PTemp['idWord'] == NTemp['idWord']) {
                    shiftNode();
                }

        }


    }//end of for in node*****************************************


    //set position x for word in ayeh*************************************************
    idNext = arrId[firstNodeId]['nextId'];
    arrId[firstNodeId]['x'] = funX("start", arrId[firstNodeId]['state'], 0);

    for (var j = 1; j < length; j++) {

        var idp = parseInt(arrId[idNext]['prevId']),
            lnPrev = arrId[idp]['length'],
            xprev = arrId[idp]['x'];

        arrId[idNext]['x'] = funX(xprev, arrId[idNext]['state'], lnPrev);
        idNext = arrId[idNext]['nextId'];
    }

    maxNumber = a - 1;
    arrId.sort(function (a, b) {
        return parseFloat(a.number) - parseFloat(b.number)
    });

    //add element for create Table of sarff*********************************8
    var elMain = document.getElementById(sarfContainerId);
    if (elMain !== null) {
        var divB = '',
            divH = '<div>',
            divtr = '',
            divth = '',
            PIW = 'one',
            Tohi = 'تهي',
            objSarff = {};
        elMain.innerHTML = '';
        for (var i in arrId) {

            if (arrId[i]['StXML']) {
                //Curent XML
                var CX = arrId[i]['StXML'];

                if (arrId[i]['idWord'] != PIW && PIW != 'one') {
                    divB += '<div class="word">' + divtr + '</div>';
                    divtr = '';
                }
                PIW = arrId[i]['idWord'];

                var rgbColor = hexToRgb(CX["color"]);

                var backColor = " style='background-color:rgba(" + rgbColor.r
                    + "," + rgbColor.g
                    + "," + rgbColor.b + ",.2)'" +
                    "   onMouseOver=\"this.style.backgroundColor='rgba(" + rgbColor.r
                    + "," + rgbColor.g
                    + "," + rgbColor.b + ",.5)'\"" +
                    "   onMouseOut=\"this.style.backgroundColor='rgba(" + rgbColor.r
                    + "," + rgbColor.g
                    + "," + rgbColor.b + ",.2)'\"";

                if (CX['Pos'] == 'حرف') {
                    objSarff['type'] = {};
                    divtr += '<div class="row"><div><span style="color:' + CX["color"] + ' ">' + CX['Slice'] + '</span></div>';
                    divtr += "<div>";
                    divtr += (CX['Pos'] != Tohi && CX['Pos'] != undefined) ? '<div><span title="قسم کلمه" ' + backColor + '>' + CX['Pos'] + ' </span></div>' : '';
                    //divtr += (CX['Affix'] == 'هسته') ? '<div><span title="ونديت" ' + backColor + '>' + CX['Affix'] + ' </span></div>' : '';
                    divtr += (CX['Kol'] != Tohi && CX['Kol'] != undefined) ? '<div><span title="نوع حرف" ' + backColor + '>' + CX['Kol'] + ' </span></div>' : '';
                    divtr += (CX['Case'] != Tohi && CX['Case'] != undefined) ? '<div><span title="اعراب" ' + backColor + '>' + CX['Case'] + ' </span></div>' : '';
                    divtr += '</div>';

                } else if (CX['Pos'] == 'اسم') {
                    divtr += '<div class="row"><div><span style="color:' + CX["color"] + ' ">' + CX['Slice'] + '</span></div>';
                    divtr += "<div>";
                    divtr += (CX['Pos'] != Tohi && CX['Pos'] != undefined) ? '<div><span title="قسم کلمه" ' + backColor + '>' + CX['Pos'] + ' </span></div>' : '';
                    //divtr += (CX['Affix'] == 'هسته') ? '<div><span title="ونديت" ' + backColor + '>' + CX['Affix'] + ' </span></div>' : '';
                    divtr += (CX['Categ'] != Tohi && CX['Categ'] != undefined) ? '<div><span title="ساختار" ' + backColor + '>' + CX['Categ'] + '</span></div>' : '';
                    divtr += (CX['Root'] != Tohi && CX['Root'] != undefined) ? '<div><span title="ریشه" ' + backColor + '> ' + CX['Root'] + '</span></div>' : '';
                    divtr += (CX['DervT'] != Tohi && CX['DervT'] != undefined) ? '<div><span title="نوع اشتقاق" ' + backColor + '> ' + CX['DervT'] + '</span></div>' : '';
                    divtr += (CX['Num'] != Tohi && CX['Num'] != undefined) ? '<div><span title="تعداد" ' + backColor + '> ' + CX['Num'] + '</span></div>' : '';
                    divtr += (CX['Gend'] != Tohi && CX['Gend'] != undefined) ? '<div><span title="تذكير و تانيث" ' + backColor + '> ' + CX['Gend'] + '</span></div>' : '';
                    divtr += (CX['Trans'] != Tohi && CX['Trans'] != undefined) ? '<div><span title="تعديه" ' + backColor + '> ' + CX['Trans'] + '</span></div>' : '';
                    divtr += (CX['Case'] != Tohi && CX['Case'] != undefined) ? '<div><span title="اعراب" ' + backColor + '> ' + CX['Case'] + '</span></div>' : '';
                    divtr += (CX['Def'] != Tohi && CX['Def'] != undefined) ? '<div><span title="تعریف" ' + backColor + '> ' + CX['Def'] + '</span></div>' : '';
                    divtr += (CX['RootT'] != Tohi && CX['RootT'] != undefined) ? '<div><span title="نوع ریشه" ' + backColor + '> ' + CX['RootT'] + '</span></div>' : '';
                    divtr += '</div>';


                } else if (CX['Pos'] == 'فعل') {
                    divtr += '<div class="row"><div><span style="color:' + CX["color"] + ' ">' + CX['Slice'] + '</span></div>';
                    divtr += "<div>";
                    divtr += (CX['Pos'] != Tohi && CX['Pos'] != undefined) ? '<div><span title="قسم کلمه" ' + backColor + '>' + CX['Pos'] + ' </span></div>' : '';
                    //divtr += (CX['Affix'] == 'هسته') ? '<div><span title="ونديت" ' + backColor + '>' + CX['Affix'] + ' </span></div>' : '';
                    divtr += (CX['Time'] != Tohi && CX['Time'] != undefined) ? '<div><span title="زمان" ' + backColor + '>' + CX['Time'] + '</span></div>' : '';
                    divtr += (CX['Categ'] != Tohi && CX['Categ'] != undefined) ? '<div><span title="ساختار" ' + backColor + '>' + CX['Categ'] + '</span></div>' : '';
                    divtr += (CX['Root'] != Tohi && CX['Root'] != undefined) ? '<div><span title="ریشه" ' + backColor + '>' + CX['Root'] + ' </span></div>' : '';
                    divtr += (CX['TOV'] != Tohi && CX['TOV'] != undefined) ? '<div><span title="شماره صيغه" ' + backColor + '>' + CX['TOV'] + ' </span></div>' : '';
                    divtr += (CX['Voic'] != Tohi && CX['Voic'] != undefined) ? '<div><span title="معلوم و مجهول" ' + backColor + '>' + CX['Voic'] + ' </span></div>' : '';
                    divtr += (CX['Trans'] != Tohi && CX['Trans'] != undefined) ? '<div><span title="تعديه" ' + backColor + '>' + CX['Trans'] + ' </span></div>' : '';
                    divtr += (CX['Case'] != Tohi && CX['Case'] != undefined) ? '<div><span title="اعراب" ' + backColor + '>' + CX['Case'] + ' </span></div>' : '';
                    divtr += (CX['Gend'] != Tohi && CX['Gend'] != undefined) ? '<div><span title="تذکیر و تأنیث" ' + backColor + '>' + CX['Gend'] + ' </span></div>' : '';
                    divtr += (CX['Gender'] != Tohi && CX['Gender'] != undefined) ? '<div><span title="تذکیر و تأنیث" ' + backColor + '>' + CX['Gender'] + ' </span></div>' : '';
                    divtr += (CX['RootT'] != Tohi && CX['RootT'] != undefined) ? '<div><span title="نوع ریشه" ' + backColor + '>' + CX['RootT'] + ' </span></div>' : '';
                    divtr += (CX['Prsn'] != Tohi && CX['Prsn'] != undefined) ? '<div><span title="شخص" ' + backColor + '>' + CX['Prsn'] + ' </span></div>' : '';
                    divtr += (CX['Num'] != Tohi && CX['Num'] != undefined) ? '<div><span title="تعداد" ' + backColor + '>' + CX['Num'] + ' </span></div>' : '';
                    divtr += '</div>';
                }
                divtr += "</div>";
            }

        }
        var info = getBrowserVer(),
            msgSupport = '';
        //if (info.browserName == 'Chrome' || info.browserName == 'Opera') {
        //    msgSupport = 'برای نمايش بهتر می توانيد از مرورگر فاير فاکس و اينترنت اکسپلورر نسخه 9 به بالا استفاده کنيد.';
        //} else if (info.browserName = 'Microsoft Internet Explorer' && info.majorVersion < 9) {

        //    msgSupport = 'برای نمايش بهتر می توانيد از مرورگر فاير فاکس و اينترنت اکسپلورر نسخه 9 به بالا استفاده کنيد.';
        //}
        divB += '<div class="word">' + divtr + '</div>';
        //divH = '<div class="word"><div><div style="color:brown; font-size: 12px;"> ' + msgSupport + ' </div></div></div>';
        divB += '</div>';
        elMain.innerHTML = divB + divH;
    //end of add element for create Table of sarff*********************************8
    }
    


    arrId = arrId.filter(Boolean);
    arrNode = arrId;
    return arrId;
}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

///Set Value For Edges////////////////////////////////////////////////
function setValEdge(edge, node) {

    var arrEdge = {}, edgeInWord = false, LNRT, ln, RL, Option = 170;

    for (var i in edge) {
        if (edge[i].relationId > 62 && edge[i].relationId < 66) {
            continue;
        }

        arrEdge[edge[i].id] = {};
        arrEdge[edge[i].id]['id'] = edge[i].id;

        edgeInWord = funGetIdWord(node, edge[i].from, edge[i].to).inWord;
        LNRT = funGetIdWord(arrNode, edge[i].from, edge[i].to);
        //ln=edge[i].from-edge[i].to;
        ln = LNRT.lenGf;
        RL = LNRT.position;
        if (ln == 1 && edgeInWord) {
            arrEdge[edge[i].id]['length'] = (ln * Option) - 15;
        } else if (ln == 1) {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 55;
        } else if (ln == 2) {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 55;
        } else if (ln == 3) {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 50;
        } else if (ln == 4) {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 50;
        } else if (ln == 7) {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 50;
        } else if (ln == 10) {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 50;
        } else if (ln == 13) {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 50;
        } else {
            arrEdge[edge[i].id]['length'] = (ln * Option) + 50;
        }
        //            else if(ln==3){
        //                arrEdge[edge[i].id]['length']=(ln*200)-100;
        //            }else{
        //                arrEdge[edge[i].id]['length']=(ln*200);
        //            }
        //
        //        }


        arrEdge[edge[i].id]['color'] = obj.relationName[edge[i].relationId].color;
        arrEdge[edge[i].id]['label'] = obj.relationName[edge[i].relationId].name;
        if ((edge[i].arrow == 'LTR' && RL == 'LTR') || (edge[i].arrow == 'RTL' && RL == 'RTL')) {
            arrEdge[edge[i].id]['from'] = edge[i].from;
            arrEdge[edge[i].id]['to'] = edge[i].to;
        }
        else {
            arrEdge[edge[i].id]['from'] = edge[i].to;
            arrEdge[edge[i].id]['to'] = edge[i].from;

        }

    }
    return arrEdge;
}

// get i=equal number part-word in sentence and type recognition of state part-word in word
// for define position of word in pivot x
function funX(xprev, type, lnprev) {

    var a = 0, x = 0, ln = 0;
    type = type.trim();
    if (xprev == "start") {
        a = -150;
    } else {
        a = xprev - (lnprev);
        //        a=xprev-(lnprev)-(lnprev/2)+15;
    }
    switch (type) {
        case 'FiEn':
            x = a - 50;
            break;
        case 'Fi':
            x = a - 50;
            break;
        case 'En':
            x = a;
            break;
        case 'Ce':
            x = a;
            break;
        case 'FiAfSpl':
            x = a;
            break;
        case 'CeBefSpl':
            x = a;
            break;
        case 'CeBefAfSpl':
            x = a;
            break;
        case 'CeAfSpl':
            x = a;
            break;
        case 'EnBefSpl':
            x = a;
            break;
        default:
            x = a;
            break;
    }
    return x;
}
// for define position of word in pivot y
function funY() {
    var y = 0;
    return y;
}
// get id attr in node property and get Object attr the define for current graph
function funAttr(id, attr) {
    var objAttr = {};
    objAttr = attr[id];
    return objAttr;
}

//

function GetItemNext(num, node) {
    var idWord = node[num]['idWord'],
        idNext = node[num]['nextId'];
    var i = funGetIndex(idNext, node);
    if (!i) {
        return null;
    }
    while ((idWord == node[i]['idWord'] || node[i]['idWord'] == null) || ((idWord != node[i]['idWord']) && (node[i]['isNewWord'] == 1))) {
        if (node[i]['isNewWord'] == 1) {
            if (node[i]['nextId'])
                i = funGetIndex(node[i]['nextId'], node);
            else
                return null;
        }
        else {
            return node[i];
        }
    }
    return null;
}

function GetItemPrev(num, node) {
    var idWord = node[num]['idWord'],
        idPrev = node[num]['prevId'],
        i = funGetIndex(idPrev, node);
    if (!i) {
        return null;
    }
    while (((idWord == node[i]['idWord']) || (node[i]['idWord'] == null)) || ((idWord != node[i]['idWord']) && (node[i]['isNewWord'] == 1))) {
        if (node[i]['isNewWord'] == 1) {
            if (node[i]['prevId'])
                i = funGetIndex(node[i]['prevId'], node);
            else
                return null;
        }
        else {
            return node[i];
        }
    }
    return null;
}

function GetItemOfNode(num, node) {

    //    if(node[num]['isNewWord']==1)
    //        return {P:null, C: node[num], N: null}
    //    else
    return { P: GetItemPrev(num, node), C: node[num], N: GetItemNext(num, node) }


    //node[PrevIndex];

}
// get id part-Word in node and object node for recognition of state part-word in word
//Reduce speed web*************************************
function funState(num, node) {


    //    var cunt = 0,
    //        temp = null,
    //        arrPart = {},
    //        p = 0,
    //        n = 0,
    //        c = 0,
    //        id = node[num].id,
    //        word = node[num]['Word'],
    //        idWord = node[num]['idWord'],
    //        idNext = node[num]['nextId'],
    //        idPrev = node[num]['prevId'],
    //        wordNext = null,
    //        wordPrev = null;

    //    for (var i in node) {
    //
    //        if (idWord == node[i]['idWord']) {
    //            if (node[i]['isNewWord'] == 1) {
    //                console.log("Var:obj1>L:559>idNext=>",idNext);
    //                console.log("Var:obj1>L:559>idPrev=>",idPrev);
    //                console.log("Var:obj1>L:559>Curent>", node[i]['id']);
    //                console.log("Var:obj1>L:559>F:QuranAnalyze.js=>", funGetIndex(node[i]['id'],node));
    //
    //                console.log("Var:obj1>L:559>F:QuranAnalyze.js=>", node[i]['Word']);
    //                if (node[i]['id'] == idNext) {
    //                    n = 1;
    //                    wordNext = node[funGetIndex(idNext,node)]['Word'];
    //                    console.log("Var:obj1>L:559>F:QuranAnalyze.js=>", wordNext);
    //                }
    //                else if (node[i]['id'] == idPrev) {
    //                    p = 1;
    //                    wordPrev = node[funGetIndex(idPrev,node)]['Word'];
    //                    console.log("Var:obj1>L:559>F:QuranAnalyze.js=>", wordPrev);
    //                } else if (node[i].id == id) {
    //                    c = 1;
    //                }
    //            } else {
    //                if (node[i]['id'] == idNext) {
    //                    n = 1;
    //                    wordNext = node[i]['Word'];
    //                }
    //                else if (node[i]['id'] == idPrev) {
    //                    p = 1;
    //                    wordPrev = node[i]['Word'];
    //                } else if (node[i].id == id) {
    //                    c = 1;
    //                }
    //            }
    //
    //
    //        }
    //
    //
    //    }


    var temp = null,
        ObjState = GetItemOfNode(num, node);

    if (ObjState['P'] == null && ObjState['N'] == null) {
        temp = "FiEn";
    } else if (ObjState['P'] == null) {
        temp = "Fi";
        temp = stickyWord(null, ObjState['C']['Word'], ObjState['N']['Word'], temp);
    } else if (ObjState['N'] == null) {
        temp = "En";
        temp = stickyWord(ObjState['P']['Word'], ObjState['C']['Word'], null, temp);
    } else {
        temp = "Ce";
        temp = stickyWord(ObjState['P']['Word'], ObjState['C']['Word'], ObjState['N']['Word'], temp)
    }
    //else {
    //        temp = "FiEn";
    //    }

    //console.log("Var:temp>L:687>F:QuranAnalyze.js=>", temp);
    //console.log("Var:ObjState>L:688>F:QuranAnalyze.js=>", ObjState['P']);
    //console.log("Var:ObjState>L:688>F:QuranAnalyze.js=>", ObjState['C']);
    //console.log("Var:ObjState>L:688>F:QuranAnalyze.js=>", ObjState['N']);
    return temp;

}
//get current group and new group for merge they to one object
function funCreateGroup(groups, newG) {
    for (var i in newG) {
        groups[newG[i].atr] = {};
        groups[newG[i].atr].fontColor = newG[i].color;
        groups[newG[i].atr].color = newG[i].color;


    }
    return groups;
}
//get node object and start(from) and end(to) for detection parts is in one word or two word
//Reduce speed web*************************************
function funGetIdWord(node, from, to) {
    //    console.log("Var:node>L:298>F:script.js=>", node);
    var idWordFrom,
        idWordTo,
        numberFrom,
        numberTo,
        resObj = { inWord: false, lenGf: 0, position: null };
    for (var i in node) {

        if (node[i].id == from) {
            idWordFrom = node[i].idWord;
            numberFrom = node[i].number
        }
        if (node[i].id == to) {
            idWordTo = node[i].idWord;
            numberTo = node[i].number;
        }
    }

    if (idWordFrom == idWordTo) {
        resObj.inWord = true;
    }
    else {
        resObj.inWord = false;
    }

    if (numberFrom > numberTo) {
        resObj.lenGf = (numberFrom - numberTo);
        resObj.position = 'LTR';
    }
    else {
        resObj.lenGf = (numberTo - numberFrom);
        resObj.position = 'RTL';
    }
    return resObj;
}

//get node object and start(from) and end(to) for space between part-word
//Reduce speed web*************************************
//function funGetLength(node,from,to){
//    for(var i in node ){
//        if(node[i].id==from){}
//        if(node[i].id==to){}
//    }
//    console.log("Var:obj>L:327>F:script.js=>", from,to);
//}
//get object node and detection between node for draw node-setting
function funGetId(node) {
    //    return 3;
    for (var i in node) {
        if (node[i].number >= (maxNumber / 2))
            return node[i].id;
    }
}

//receive id of node and return index
function funGetIndex(id, node) {
    for (var i in node)
        if (id == node[i]['id'])
            return i;

    return false;
}

function GetLengthText(text) {
    var OPT = optionsInit.groups.W,
        c = document.getElementById(idCanvas),
        ctx = c.getContext("2d");
    ctx.font = "" + OPT.fontSize + "px " + OPT.fontFace + "";
    ctx.fillText(text, 50, 55);
    //console.log("Var:ctx.measureText(text)>L:777>F:QuranAnalyze.js=>", text);
    //console.log("Var:(ctx.measureText(text).width)>L:777>F:QuranAnalyze.js=>", (ctx.measureText(text).width));
    return ((ctx.measureText(text).width));


}
///get node and id of word  return state sticky
function stickyWord(strPrev, strSelf, strNext, state) {


    if (state == 'Fi' && strSelf && strNext) {
        strSelf = stripTashkeel(strSelf);
        if (checkCharSticky(strSelf.substring(strSelf.length - 1))) {
            state = 'FiAfSpl';
        }
    } else if (state == 'En' && strPrev && strSelf) {
        strPrev = stripTashkeel(strPrev);
        if (checkCharSticky(strPrev.substring(strPrev.length - 1))) {
            state = 'EnBefSpl';
        }
    } else if (strPrev && strSelf && strNext) {//Ce
        strPrev = stripTashkeel(strPrev);
        strSelf = stripTashkeel(strSelf);
        if (checkCharSticky(strSelf.substring(strSelf.length - 1))) {
            state = 'CeAfSpl';
            if (checkCharSticky(strPrev.substring(strPrev.length - 1))) {
                state = 'CeBefAfSpl';
            }
        } else if (checkCharSticky(strPrev.substring(strPrev.length - 1))) {
            state = 'CeBefSpl';
        }

    }

    return state;
}


function checkCharSticky(strChar) {
    //console.log("Var:strChar>L:697>F:QuranAnalyze.js=>", strChar);
    var arrChar = ['آ', 'ا', 'و', 'ز', 'ر', 'ژ', 'د', 'ذ', 'ء', 'ؤ', 'أ', 'إ']
    for (var i in arrChar) {
        if (arrChar[i] == strChar)
            return true;

    }
    if (strChar == 'ّ') {
        alert('');

    }
    return false;

}


////////////////////////////////////////Convert Text To Text without
var CHARCODE_SHADDA = 1617;
var CHARCODE_SUKOON = 1618;
var CHARCODE_SUPERSCRIPT_ALIF = 1648;
var CHARCODE_TATWEEL = 1600;
var CHARCODE_ALIF = 1575;

function isCharTashkeel(letter) {
    if (typeof (letter) == "undefined" || letter == null)
        return false;

    var code = letter.charCodeAt(0);
    //1648 - superscript alif
    //1619 - madd: ~
    return (code == CHARCODE_TATWEEL || code == CHARCODE_SUPERSCRIPT_ALIF || code >= 1612 && code <= 1631); //tashkeel
}

function stripTashkeel(input) {
    var output = "";
    //todo consider using a stringbuilder to improve performance
    for (var i = 0; i < input.length; i++) {
        var letter = input.charAt(i);
        if (!isCharTashkeel(letter)) //tashkeel
            output += letter;
    }


    return output;
}

function SetIdForNameObjRelation(objRelation) {
    var tempObj = {};
    var data = objRelation.Data;
    for (var item in data) {
        tempObj[data[item].Id] = data[item]
    }
    return tempObj;
}


